(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initForm(form) {
      if (form.dataset.ccInit === '1') return;
      form.dataset.ccInit = '1';
      var variantTag = form.dataset.variant || 'variant-a';
      var sectionId = form.id.split('cc-final-form-')[1];
      var success = document.getElementById('cc-final-success-' + sectionId);

      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        var data = new FormData(form);
        var email = data.get('email');
        var store = data.get('store') || '';
        var question = data.get('question') || '';
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Reserving...'; }

        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'clear-customers-waitlist, ' + variantTag);
        var noteLines = ['Variant: ' + variantTag, 'Source: final'];
        if (store) noteLines.push('Store: ' + store);
        if (question) noteLines.push('Biggest question: ' + question);
        fd.append('contact[note]', noteLines.join(' | '));
        fd.append('contact[accepts_marketing]', 'true');

        try {
          await fetch('/contact#contact_form', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        } catch (err) { /* CORS expected — signup processes anyway */ }
        form.querySelectorAll('input, textarea, button').forEach(function(el) { el.style.display = 'none'; });
        if (success) success.classList.add('show');
      });
    }
    document.querySelectorAll('[id^="cc-final-form-"]').forEach(initForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initForm(form) {
      if (form.dataset.ccInit === '1') return;
      form.dataset.ccInit = '1';
      var variantTag = form.dataset.variant || 'variant-a';
      var sectionId = form.id.split('cc-hero-form-')[1];
      var success = document.getElementById('cc-hero-success-' + sectionId);
      var formType = 'hero';

      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        var data = new FormData(form);
        var email = data.get('email');
        var store = data.get('store') || '';
        var question = data.get('question') || '';
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Reserving...'; }

        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'clear-customers-waitlist, ' + variantTag);
        var noteLines = ['Variant: ' + variantTag, 'Source: ' + formType];
        if (store) noteLines.push('Store: ' + store);
        if (question) noteLines.push('Biggest question: ' + question);
        fd.append('contact[note]', noteLines.join(' | '));
        fd.append('contact[accepts_marketing]', 'true');

        try {
          await fetch('/contact#contact_form', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        } catch (err) { /* CORS errors are expected — signup still processes */ }
        form.querySelectorAll('input, textarea, button').forEach(function(el) { el.style.display = 'none'; });
        if (success) success.classList.add('show');
      });
    }
    document.querySelectorAll('[id^="cc-hero-form-"]').forEach(initForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
